import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Shield, ArrowRight, ChevronRight } from 'lucide-react';
import { productData } from '../mockData';
import RadarEffect from '../components/RadarEffect';
import DroneHeads from '../components/DroneHeads';

const Home = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="dark-page defense-page">
      <section className="defense-hero">
        <div className="hero-background">
          <RadarEffect />
        </div>
        
        <div className="defense-hero-content">
          <div className="hero-left">
            <div className="classification-badge">AUTONOMOUS DEFENSE</div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '24px' }}>
              <h1 className="defense-headline">Wolf Eye</h1>
              <img 
                src="https://customer-assets.emergentagent.com/job_wolf-eye/artifacts/rqhhmtcv_Wolf%20Eye%20LOGO%20-%20Copy.png"
                alt="Wolf Eye"
                style={{ height: '80px', objectFit: 'contain' }}
              />
            </div>
            <h2 className="defense-subheadline">Modular Counter-UAS System</h2>
            <p className="defense-description">
              Next-generation autonomous aerial defense. 6-9 drones per module. 
              Deployment in under 30 minutes.
            </p>
            
            <div className="hero-stats-inline">
              <div className="stat-inline">
                <span className="stat-number">€90K</span>
                <span className="stat-text">Per Module</span>
              </div>
              <div className="stat-divider"></div>
              <div className="stat-inline">
                <span className="stat-number">480</span>
                <span className="stat-text">km/h Max Speed</span>
              </div>
              <div className="stat-divider"></div>
              <div className="stat-inline">
                <span className="stat-number">24/7</span>
                <span className="stat-text">Operation</span>
              </div>
            </div>

            <div className="hero-cta-group">
              <Link to="/product" className="btn-primary-large">
                <span>Technical Specifications</span>
                <ChevronRight size={20} />
              </Link>
              <Link to="/contact" className="btn-secondary-outline">
                Request Deployment Brief
              </Link>
            </div>
          </div>

          <div className="hero-right">
            <div className="hero-drone-showcase">
              <img 
                src="https://customer-assets.emergentagent.com/job_wolf-eye/artifacts/qr4l4fxp_Drone%20image%201%23-Photoroom.png"
                alt="Wolf Eye Interceptor Drone"
                className="drone-hero-image"
              />
              <div className="drone-glow-effect"></div>
            </div>
            <div className="viewer-label">Interceptor Configuration</div>
          </div>
        </div>
      </section>

      <section className="drone-heads-wrapper">
        <DroneHeads />
      </section>

      <section className="capabilities-section">
        <div className="section-tag">OPERATIONAL CAPABILITIES</div>
        <h2 className="section-title-large">Combat-Ready Technology</h2>
        
        <div className="capabilities-grid">
          <div className="capability-card">
            <div className="capability-metric">6-9</div>
            <div className="capability-label">Drones Per Module</div>
            <p className="capability-desc">Standardized components for rapid reconfiguration and deployment</p>
          </div>

          <div className="capability-card">
            <div className="capability-metric">{'<'}30min</div>
            <div className="capability-label">Deployment Time</div>
            <p className="capability-desc">From transport to full operational status in under 30 minutes</p>
          </div>

          <div className="capability-card">
            <div className="capability-metric">150+</div>
            <div className="capability-label">Module Network</div>
            <p className="capability-desc">Scalable from 5 modules (infrastructure) to 150+ (city-scale)</p>
          </div>

          <div className="capability-card">
            <div className="capability-metric">AI</div>
            <div className="capability-label">Autonomous Operation</div>
            <p className="capability-desc">Degraded comms resilience with autonomous decision-making</p>
          </div>
        </div>
      </section>

      <section className="final-cta-section">
        <div className="final-cta-content">
          <h2 className="cta-headline">Deploy Wolf Eye</h2>
          <p className="cta-subtext">
            Enterprise-grade autonomous defense at €90,000 per module.
            <br />Contact our team for technical briefings and deployment planning.
          </p>
          <div className="cta-buttons">
            <Link to="/contact" className="btn-primary-large">
              <span>Request Quote</span>
              <ChevronRight size={20} />
            </Link>
            <Link to="/product" className="btn-secondary-outline">
              Technical Documentation
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;